// constants
import { OrdersActionTypes } from "./constants";

//Action
export interface OrdersActionType {
  type:
    | OrdersActionTypes.GET_LIST_ORDERS_ERROR
    | OrdersActionTypes.GET_LIST_ORDERS_SUCCESS
    | OrdersActionTypes.GET_LIST_ORDERS
    | OrdersActionTypes.CREATE_ORDER
    | OrdersActionTypes.CREATE_ORDER_SUCCESS
    | OrdersActionTypes.CREATE_ORDER_ERROR
    | OrdersActionTypes.GET_ORDER
    | OrdersActionTypes.GET_ORDER_SUCCESS
    | OrdersActionTypes.GET_ORDER_ERROR
    | OrdersActionTypes.UPDATE_ORDER
    | OrdersActionTypes.UPDATE_ORDER_SUCCESS
    | OrdersActionTypes.UPDATE_ORDER_ERROR
    | OrdersActionTypes.UPDATE_STATUS_ORDER
    | OrdersActionTypes.UPDATE_STATUS_ORDER_SUCCESS
    | OrdersActionTypes.UPDATE_STATUS_ORDER_ERROR
    | OrdersActionTypes.DELETE_ORDER
    | OrdersActionTypes.DELETE_ORDER_SUCCESS
    | OrdersActionTypes.DELETE_ORDER_ERROR
    | OrdersActionTypes.DOWNLOAD_SAMPLE
    | OrdersActionTypes.DOWNLOAD_SAMPLE_SUCCESS
    | OrdersActionTypes.DOWNLOAD_SAMPLE_ERROR
    | OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS
    | OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_SUCCESS
    | OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_ERROR
    | OrdersActionTypes.BULK_UPDATE_AGENT
    | OrdersActionTypes.BULK_UPDATE_AGENT_SUCCESS
    | OrdersActionTypes.BULK_UPDATE_AGENT_ERROR;
  payload: {} | string;
}

//Interfaces
interface OrdersData {
  iteam?: any[];
  total?: number;
  country?: string;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface OrderCreate {
  country: string;
  comment: string;
  description: string;
  orderDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}

interface OrderUpdate {
  comment: string;
  description: string;
  orderDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}

interface GetOrder {
  id: string;
}

interface DeleteOrder {
  ids: string[];
}

//Order_List
export const ordersGetListSuccess = (
  actionType: string,
  data: OrdersData | {}
): OrdersActionType => ({
  type: OrdersActionTypes.GET_LIST_ORDERS_SUCCESS,
  payload: { actionType, data },
});

export const ordersGetListError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.GET_LIST_ORDERS_ERROR,
  payload: { actionType, error },
});

export const getOrdersList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  country: string = "ic",
  status: string = "",
  agent: string = "",
  product: string = "",
  boutique: string = ""
): OrdersActionType => ({
  type: OrdersActionTypes.GET_LIST_ORDERS,
  payload: { keyword, limit, skip, owner, country, status, agent, product, boutique },
});

//Create Order
export const createOrderSuccess = (
  actionType: string,
  data: OrderCreate | {}
): OrdersActionType => ({
  type: OrdersActionTypes.CREATE_ORDER_SUCCESS,
  payload: { actionType, data },
});
export const createOrderError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.CREATE_ORDER_ERROR,
  payload: { actionType, error },
});
export const createOrder = (
  country: string,
  product: string,
  customerName: string,
  customerPhone: string,
  customerAddress: string,
  price: number,
  quantity: number,
  sourceLink: string,
  sourceName: string,
  totalPrice: number
): OrdersActionType => ({
  type: OrdersActionTypes.CREATE_ORDER,
  payload: {
    country,
    product,
    customerName,
    customerPhone,
    customerAddress,
    price,
    quantity,
    sourceLink,
    sourceName,
    totalPrice,
  },
});

//Update Order
export const updateOrderSuccess = (
  actionType: string,
  data: OrderUpdate | {}
): OrdersActionType => ({
  type: OrdersActionTypes.UPDATE_ORDER_SUCCESS,
  payload: { actionType, data },
});
export const updateOrderError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.UPDATE_ORDER_ERROR,
  payload: { actionType, error },
});

export const updateOrder = (
  id: string,
  data: OrderUpdate
): OrdersActionType => ({
  type: OrdersActionTypes.UPDATE_ORDER,
  payload: { id, ...data },
});

//Update Status Order
export const updateStatusOrderSuccess = (
  actionType: string,
  data: OrderUpdate | {}
): OrdersActionType => ({
  type: OrdersActionTypes.UPDATE_STATUS_ORDER_SUCCESS,
  payload: { actionType, data },
});
export const updateStatusOrderError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.UPDATE_STATUS_ORDER_ERROR,
  payload: { actionType, error },
});

export const updateStatusOrder = (
  id: string,
  {
    status,
    comment,
    delivery,
    quantity,
    totalPrice,
    affiliateAddOns,
    disposition,
    callbackAt,
    scheduledFor,
  }: {
    status: string;
    comment: string;
    delivery?: string;
    quantity?: number;
    totalPrice?: number;
    affiliateAddOns?: { affiliateId: string; quantity: number; unitPrice?: number }[];
    disposition?: string;
    callbackAt?: string;
    scheduledFor?: string;
  }
): OrdersActionType => ({
  type: OrdersActionTypes.UPDATE_STATUS_ORDER,
  payload: { id, status, comment, delivery, quantity, totalPrice, affiliateAddOns, disposition, callbackAt, scheduledFor },
});

//GET Order

export const getOrderSuccess = (
  actionType: string,
  data: GetOrder | {}
): OrdersActionType => ({
  type: OrdersActionTypes.GET_ORDER_SUCCESS,
  payload: { actionType, data },
});
export const getOrderError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.GET_ORDER_ERROR,
  payload: { actionType, error },
});

export const getOrder = (id: string): OrdersActionType => ({
  type: OrdersActionTypes.GET_ORDER,
  payload: { id },
});

//DELETE Order

export const deleteOrderSuccess = (
  actionType: string,
  data: DeleteOrder | {}
): OrdersActionType => ({
  type: OrdersActionTypes.DELETE_ORDER_SUCCESS,
  payload: { actionType, data },
});
export const deleteOrderError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.DELETE_ORDER_ERROR,
  payload: { actionType, error },
});

export const deleteOrder = (ids: string[]): OrdersActionType => ({
  type: OrdersActionTypes.DELETE_ORDER,
  payload: { ids },
});

// Download Sample Sheet

export const orderSampleDownloadSuccess = (
  actionType: string,
  data: {}
): OrdersActionType => ({
  type: OrdersActionTypes.DOWNLOAD_SAMPLE_SUCCESS,
  payload: { actionType, data },
});
export const orderSampleDownloadError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.DOWNLOAD_SAMPLE_ERROR,
  payload: { actionType, error },
});

export const orderSampleDownload = (): OrdersActionType => ({
  type: OrdersActionTypes.DOWNLOAD_SAMPLE,
  payload: {},
});

// Upload Orders
export const uploadOrdersSuccess = (
  actionType: string,
  data: {} | FormData
): OrdersActionType => ({
  type: OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_SUCCESS,
  payload: { actionType, data },
});

export const uploadOrdersError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS_ERROR,
  payload: { actionType, error },
});

export const uploadOrders = (file: FormData): OrdersActionType => ({
  type: OrdersActionTypes.UPLOAD_MULTIPLE_ORDERS,
  payload: { file },
});

export const bulkUpdateAgentSuccess = (
  actionType: string,
  data: any
): OrdersActionType => ({
  type: OrdersActionTypes.BULK_UPDATE_AGENT_SUCCESS,
  payload: { actionType, data },
});

export const bulkUpdateAgentError = (
  actionType: string,
  error: string
): OrdersActionType => ({
  type: OrdersActionTypes.BULK_UPDATE_AGENT_ERROR,
  payload: { actionType, error },
});

export const bulkUpdateAgent = (
  orderIds: string[],
  agentId: string
): OrdersActionType => ({
  type: OrdersActionTypes.BULK_UPDATE_AGENT,
  payload: { orderIds, agentId },
});
